import planEnum from './planEnum';

// NOTE: 兼容 origin / pro 方案
const planCardListBackup = [
  {
    planKeyName: planEnum.BASIC,
    planPrice: {
      mo: 0,
      yr: 0,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 0,
      },
      yr: {
        isActive: false,
        price: 0,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: false,
      videoClip: false,
      sleepTracking: false,
      snapCute: false,
    },
    featureData: {
      eventVideoDay: 7,
      continuousVideoDay: 10,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.ADVANCE,
    planPrice: {
      mo: 2.99,
      yr: 29.9,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 2.99,
      },
      yr: {
        isActive: false,
        price: 29.9,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: false,
      videoClip: false,
      sleepTracking: false,
      snapCute: false,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 10,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.PREMIER,
    planPrice: {
      mo: 9.99,
      yr: 99,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 9.99,
      },
      yr: {
        isActive: true,
        price: 69.3,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: true,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 10,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.ELITE,
    planPrice: {
      mo: 19.99,
      yr: 199,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 19.99,
      },
      yr: {
        isActive: true,
        price: 139.3,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: true,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 30,
    },
    showTag: true,
  },
  {
    planKeyName: planEnum.ADVANCE_PRO,
    planPrice: {
      mo: 8,
      yr: 80,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 2.99,
      },
      yr: {
        isActive: false,
        price: 29.9,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: false,
      videoClip: false,
      sleepTracking: false,
      snapCute: false,
      breathing: true,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 6,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.PREMIUM_PRO,
    planPrice: {
      mo: 13,
      yr: 130,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 9.99,
      },
      yr: {
        isActive: true,
        price: 69.3,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: false,
      breathing: true,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 6,
    },
    showTag: false,
  },
  {
    planKeyName: planEnum.ELITE_PRO,
    planPrice: {
      mo: 24,
      yr: 240,
    },
    planSpecialPrice: {
      mo: {
        isActive: false,
        price: 19.99,
      },
      yr: {
        isActive: true,
        price: 139.3,
      },
    },
    isFeatureActiveMap: {
      eventVideo: true,
      continuousVideo: true,
      videoClip: true,
      sleepTracking: true,
      snapCute: true,
      breathing: true,
    },
    featureData: {
      eventVideoDay: 30,
      continuousVideoDay: 30,
    },
    showTag: true,
  },
];

export default planCardListBackup;
